<template>
  <div style="width:100%">
    <el-tooltip placement="top" v-if="female_ratio&&!(female_ratio==0&&male_ratio==0)">
      <div slot="content">女性:{{ female_ratio }}%&nbsp;&nbsp;男性:{{ male_ratio }}%</div>
      <div class="gender-bar-list" id="gender-list">
        <div class="female-box-list" :style="'width:' + female_ratio + '%'"></div>
        <div class="male-box-list" :style="'width:' + male_ratio + '%'"></div>
      </div>
    </el-tooltip>
    <el-tooltip v-else> 
      <div slot="content">男女比を出すためのフォロワーの性別データが不十分です</div>
      <div class="gender-bar-nodata" id="gender-list"></div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "genderRatio",
  props: ["female_ratio", "male_ratio"],
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
